// How this document came to be loaded, sent with the sign-in call as query parameters so the server's request
// log shows it without any server change. Safari on iPhone sometimes loads the menu a second time a few seconds
// after a QR scan: a new anonymous user, and the table is lost when the URL no longer carries it.
//   nav:  this document's navigation type (navigate, reload, back_forward, prerender)
//   rc:   redirects on the way here
//   prev: "alive" when the previous document in this tab never ran pagehide, i.e. its process was killed;
//         "gone" when it unloaded normally; "none" when the tab had no earlier document
const KEY = 'collins_doc_alive';

export const loadDiag = (() => {
  let nav = 'unknown';
  let rc = '';
  try {
    const n = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    if (n) {
      nav = n.type;
      rc = String(n.redirectCount);
    }
  } catch {}
  let prev = 'none';
  try {
    const v = sessionStorage.getItem(KEY);
    prev = v === '1' ? 'alive' : v === '0' ? 'gone' : 'none';
    sessionStorage.setItem(KEY, '1');
    window.addEventListener('pagehide', () => {
      try { sessionStorage.setItem(KEY, '0'); } catch {}
    });
  } catch {}
  return { nav, rc, prev };
})();

export function loadDiagQuery(): string {
  return `nav=${loadDiag.nav}&rc=${loadDiag.rc}&prev=${loadDiag.prev}`;
}
